import { useLocation } from 'react-router-dom';

function useCanonicalUrl() {
  const location = useLocation();
  const baseUrl = process.env.PUBLIC_URL; // Replace with your base URL

  return `${baseUrl}${location.pathname}`;
}

export default useCanonicalUrl;
